export const apiUrls = {
  restaurantlisting: "restaurant-listing",
  lineLogin:"line-login",
  googleLogin:"google-login",
  categorylisting:"category-listing",
  promotion:"promotion",
  eventlisting:"event-listing",
  foodtrucklisting:"food-truck-listing",
  menulisting:"menu-listing",
  restaurantdetail:"restaurant-detail",
  foodtruckdetail:"food-truck-detail",
  menudetail:"menu-detail",
  cartadd:"cart/add",
  cartview:"cart/view",
  cartremove:"cart/remove",
  cartupdatequantity:"cart/update-quantity",
  login:"login",
  verifyotp:"verify-otp",
  profile:"profile",
  updateprofile:"update-profile",
  updateprofileimage:"update-profile-image",
  addressview:"address/view",
  adminsettings:"admin-settings",
  address:"address/add",
  addressedit:"address/edit",
  addressdelete:"address/delete",
  deleteaccount:"delete-account",
  contentlisting:"content-listing",
  contentdetail:"content-detail",
  togglewishlist:"toggle-wishlist",
  viewwishlist:"view-wishlist",
  search:"search",
  eventenquiry:"event-enquiry",
  reservationcheckout:"reservation-checkout",
   availableTables: "available-tables",
  checkoutestimate:"checkout-estimate",
  getCoupons:"get-coupons",
  applyCoupon:"apply-coupon",
  removeCoupon:"remove-coupon",
  checkout:"checkout",
  stripeverifysession:"stripe/verify-session",
  orderhistory:"order-history",
  orderinvoice:"order-invoice",
  reservationcharge:"reservation-charge",
  reservationverifysession:"reservation-verify-session",
  reservationinvoice:"reservation-invoice",
  review:"review",
  bannersettings:"banner-settings",
  resturantserviceslisting:"resturant-services-listing",
  recruitments:"recruitments",
  activeresturantserviceslisting:"active-resturant-services-listing",
  contactussubmit:"contact-us/submit",
  cateringsubmit:"catering/submit",
  announcements:"announcements",
  pages:"pages"
};
